<template>
  <div ref="banner"
       class="category-banner-vue"
       :class="{'category-banner-vue--root': isRootCategory}"
       v-if="bannerBg.url"
       :style="{ backgroundImage: `url(${bannerBg.url})`, backgroundPosition: bannerBg.position }">
    <div class="page-container category-banner-vue__svg-wrapper" v-if="bannerSvg">
      <div class="category-banner-vue__svg" :style="{ backgroundImage: `url(${bannerSvg.url})`, backgroundPosition: bannerSvg.position }"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['bannerInfo', 'isRootCategory'],
  name: 'CategoryBanner',
  data () {
    return {
      parsedBannerInfo: JSON.parse(this.bannerInfo),
      bannerBg: ''
    }
  },
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    bannerSvg () {
      return this.parsedBannerInfo.text
    }
  },
  methods: {
    setBannerBg () {
      if (window.matchMedia(`(min-width: 1023px)`).matches) {
        this.bannerBg = this.parsedBannerInfo.bg_l
      } else if (window.matchMedia(`(min-width: 768px)`).matches && window.matchMedia(`(max-width: 1024px)`).matches) {
        this.bannerBg = this.parsedBannerInfo.bg_m
      } else {
        this.bannerBg = this.parsedBannerInfo.bg_s
      }
    }
  },
  mounted () {
    this.setBannerBg()
    setTimeout(() => {
      window.onresize = this.setBannerBg
    }, 0)
  }
}
</script>

<style scoped lang="sass">

.category-banner-vue
  height: 150px
  display: flex
  align-items: center
  background-size: cover
  margin-bottom: 28px

  +mmin(768)
    height: 320px

  +mmin($tablet--hor)
    margin-bottom: 0

  &--root
    display: none

  +mmin($tablet--hor)
    display: flex

.category-banner-vue__svg-wrapper
  display: flex
  align-items: center

.category-banner-vue__svg
  background-size: contain
  background-repeat: no-repeat
  background-position: 50%
  height: 120px
  width: 100%

  +mmin(768)
    height: 280px

</style>
